// src/helpers/categoryNavigator.js
//
// 카테고리 항목(type/link) → 목적지 라우팅 규칙.
// App(lib/utils/category_navigator.dart)과 동일한 규칙을 웹에 적용한다.
// 홈 카테고리 그리드와 CATEGORY 타입 메인 배너가 공유한다.
import { toast } from "react-toastify";
import { trackCategoryClick } from "./clickTracking";

export function navigateToCategoryItem(item, navigate) {
  // 모든 홈 카테고리 타일 + CATEGORY 배너가 이 함수를 통과한다.
  // 집계는 fire-and-forget — 실패해도 아래 navigation 은 그대로 진행된다.
  trackCategoryClick(item);

  switch (item?.type) {
    case "external_url": {
      // Backend `link` is the source of truth for every external_url category.
      const url = item?.link ?? "";
      if (!url) return;
      window.open(url, "_blank", "noopener,noreferrer");
      return;
    }
    case "internal_route":
      switch (item?.link) {
        case "halal_map":
          navigate("/halal-map");
          return;
        case "community":
          navigate("/community");
          return;
        case "visa":
          navigate("/visa");
          return;
        case "airport":
          navigate("/airport");
          return;
        case "delivery":
          navigate("/delivery");
          return;
        // 'qibla' is filtered out at the store; case kept for safety.
        case "qibla":
          return;
        default:
          // Unknown internal_route — add a case above when a new in-app
          // destination is wired.
          toast.info("Coming soon");
          return;
      }
    case "service":
    default:
      navigate(`/category?categoryId=${encodeURIComponent(String(item.id))}`);
      return;
  }
}
